import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  text: {
    fontSize: 14,
  },
  label: {
    marginRight: theme.spacing(1),
    color: theme.palette.disabled.main,
  },
})

const LabelledValue = ({
  classes,
  label,
  labelIcon: LabelIcon,
  labelClassname,
  value,
}) => (
  <div className={classes.root}>
    <Typography className={classNames(classes.text, classes.label)}>
      {label}{' '}
    </Typography>
    {LabelIcon && <LabelIcon color="disabled" className={labelClassname} />}
    <Typography className={classNames(classes.text, classes.value)}>
      {value}
    </Typography>
  </div>
)

LabelledValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  labelIcon: PropTypes.any,
  classes: PropTypes.object,
  labelClassname: PropTypes.string,
}

export default withStyles(styles)(LabelledValue)



// WEBPACK FOOTER //
// ./src/components/atoms/LabelledValue.js